export default {
  acceptTermsRequired: 'कृपया अटी स्वीकारा',
  accountNumber: 'खाते क्रमांक',
  acknowledgeText: 'स्वीकारा',
  acknowledgedText: 'स्वीकारले',
  active: 'कार्यरत',
  activeBookings: 'सक्रिय बुकिंग',
  activeBucketsText: 'अॅक्टिव्ह बकेट्स',
  activeToday: 'आज कार्यरत',
  adminRole: 'ॲडमिन — व्यवस्थापकीय संचालक',
  advance: 'अग्रिम',
  advancePaid: 'अग्रिम भरले',
  advancePaidLabel: 'अग्रिम',
  agreeTermsCheckbox: 'मी सर्व अटी वाचल्या आहेत आणि मान्य आहेत',
  agreement: 'अटी आणि करार',
  alertLog: 'अलर्ट लॉग',
  alertText: 'अलर्ट',
  alerts: 'अलर्ट',
  allAlerts: 'सर्व सूचना',
  allLoaded: 'सर्व लोड झाले',
  allMachinesOk: 'सर्व मशीन व्यवस्थित चालू आहेत.',
  allStats: 'संपूर्ण आकडेवारी',
  allowedText: 'परवानगी',
  amount: 'रक्कम',
  apiHealthTitle: 'API हेल्थ',
  apiSloAlertsTitle: 'API SLO अलर्ट्स',
  appName: 'डेवलपमेंट एक्सप्रेस',
  approvals: 'मंजुरी',
  approveAndDispatch: 'मंजूर करा आणि मशीन डिस्पॅच करा',
  approved: 'मंजूर',
  assignedOperator: 'नियुक्त ऑपरेटर',
  attemptsLabel: 'प्रयत्न',
  attendance: 'हजेरी',
  auditLogs: 'ऑडिट लॉग्स',
  available: 'उपलब्ध',
  availableMachinery: 'उपलब्ध मशिनरी',
  availableNow: 'आता उपलब्ध',
  avgRating: 'सरासरी रेटिंग',
  awaitingClientFeedback: 'ग्राहक फीडबॅकची प्रतीक्षा',
  awaitingDispatch: 'डिस्पॅचची प्रतीक्षा',
  back: 'मागे जा',
  backToLogin: 'लॉगिनकडे परत जा',
  bank: 'बँक',
  bankDetailsTitle: 'बँक तपशील',
  baseAmount: 'मूळ रक्कम',
  billingWallet: 'वॉलेट आणि बिलिंग',
  blacklistWarning: '⛔ ब्लॅकलिस्ट चेतावणी',
  blockedRateText: 'ब्लॉक रेट',
  blockedText: 'ब्लॉक',
  bookMachine: 'मशीन बुक करात',
  bookMachineAction: 'मशीन बुक करा',
  bookNow: 'आत्ता बुक करा',
  bookingConfirm: 'बुकिंग पुष्टी करा',
  bookingCostCalculator: 'बुकिंग आणि खर्च कॅल्क्युलेटर',
  bookingFailedGeneric: 'बुकिंग अयशस्वी. पुन्हा प्रयत्न करा.',
  bookingHistory: 'बुकिंग इतिहास',
  bookingReportTitle: 'बुकिंग रिपोर्ट',
  bookingScheduleSummary: 'दिवस आणि महिन्यानुसार बुकिंग शेड्यूल',
  bookingSelectMachineFirst: 'पुढे जाण्यासाठी fleet मधून machine निवडा.',
  bookingStepChoose: 'मशीन निवडा',
  bookingStepConfirm: 'Confirm आणि Pay',
  bookingStepCost: 'खर्च आणि तारीख',
  bookingType: 'बुकिंग प्रकार निवडा',
  bookingTypeLabel: 'बुकिंग प्रकार',
  bookingTypeText: 'बुकिंग प्रकार',
  bookingsCount: '{count} बुकिंग',
  bookingsScheduleHint: 'ग्राहक बुकिंग केल्यावर दिवसानुसार वेळापत्रक येथे दिसेल.',
  burstText: 'बर्स्ट',
  busy: 'व्यस्त',
  callNow: 'आता कॉल करा',
  cancel: 'रद्द करा',
  cancelAction: 'रद्द करा',
  cancelBooking: 'बुकिंग रद्द करा',
  cancelBookingPrompt: 'बुकिंग रद्द करायचे?',
  cancelPolicy: 'रद्दीकरण नीती',
  cancelText: 'रद्द',
  cancelWarning: 'तुम्हाला रद्द करायचे आहे का?',
  changeLanguage: 'भास बदलात',
  changeMachine: 'मशीन बदला',
  changeMobileNumber: 'मोबाईल नंबर बदला',
  chipAction: 'action',
  chipActor: 'actor',
  chipEntity: 'entity',
  chipFrom: 'from',
  chipMeta: 'meta',
  chipRole: 'role',
  chipTo: 'to',
  clearAll: 'सर्व साफ करा',
  client: 'ग्राहक',
  clientFeedbackLabel: 'ग्राहक फीडबॅक',
  clientPortal: 'क्लायंट पोर्टल',
  clientRatingsTitle: 'ग्राहक रेटिंग आणि सूचना',
  clientRole: 'ग्राहक (कंत्राटदार)',
  clients: 'ग्राहक',
  commission: 'कमिशन',
  commission15: 'कमिशन 15%',
  commissionPaid: 'कमिशन भरले',
  commissionRate: 'एकूण बिलिंगचे 15%',
  company: 'कंपनी',
  companyDetailsTitle: 'कंपनी तपशील',
  completeBookings: 'पूर्ण झालेल्या बुकिंग',
  completedBookings: 'पूर्ण बुकिंग',
  condition: 'स्थिती',
  confirm: 'निश्चित करात',
  confirmBooking: 'बुकिंग पुष्टी करा',
  confirmBookingAction: 'बुकिंगची पुष्टी करा',
  confirmCancel: 'रद्द करणे पुष्टी करा',
  confirmPassword: 'पासवर्ड पुन्हा टाका',
  confirmRetry: 'पुन्हा प्रयत्न पुष्टी करा',
  contactCompany: 'डेव्हलपमेंट एक्सप्रेसशी संपर्क',
  costCalculator: 'खर्च कॅल्क्युलेटर',
  crawlerNoRto: 'क्रॉलर (RTO नाही)',
  currentlyDeployed: 'सध्या डिप्लॉय',
  customAmount: 'कस्टम रक्कम (UPI/कार्ड ₹1 पासून)',
  cycles: "सायकल",
  dailyWorkReport: 'दैनिक कामाचा रिपोर्ट',
  dashboard: 'डॅशबोर्ड',
  date: 'तारीख',
  dayMachinesLabel: 'मशीन',
  days: 'दिवस',
  daysUnit: 'दिवस',
  directContactBlacklist: 'थेट संपर्क = ब्लॅकलिस्ट',
  directContactProhibited: 'थेट संपर्क कठोरपणे निषिद्ध',
  directContactProhibitedText: 'थेट संपर्क कडकपणे निषिद्ध',
  dispatched: 'डिस्पॅच झाले',
  dlqMonitor: 'DLQ मॉनिटर',
  docChassisPlate: 'चेसिस / सीरियल प्लेट फोटो (RTO RC नाही)',
  docEquipmentPhoto: 'पूर्ण मशीन फोटो (साइड)',
  docIdentity: 'PAN / आधार',
  docInsurance: 'विमा प्रमाणपत्र',
  docInsuranceOptional: 'विमा / उपकरण कव्हर (उपलब्ध असल्यास)',
  docMachineInvoice: 'मशीन खरेदी / इन्वॉइस',
  docPollution: 'प्रदूषण प्रमाणपत्र (PUC)',
  docRcBook: 'RC बुक (RTO नोंदणी प्रमाणपत्र)',
  documentUploadTitle: 'कागदपत्रे अपलोड',
  documents: 'कागदपत्रे अपलोड',
  download: 'डाउनलोड',
  drawerMenu: 'मेनू',
  earnings: 'कमाई',
  email: 'ईमेल मदत',
  emailAddress: 'ईमेल पत्तो',
  emailAddressLabel: 'ईमेल पत्ता',
  expandBookingHint: 'संपूर्ण बुकिंग, cancel आणि ऑपरेटर रेटिंगसाठी खाली महिना/दिवस विभाग expand करा.',
  experience: 'अनुभव',
  exportCsv: 'CSV एक्सपोर्ट',
  failedText: 'अयशस्वी',
  feedbackAfterDispatch: 'मशीन डिस्पॅच झाल्यानंतर ऑपरेटर रेटिंग उपलब्ध होईल.',
  feedbackStatusAfterDispatch: 'डिस्पॅच नंतर',
  feedbackStatusRateNow: 'ऑपरेटर रेट करा ↓',
  filterAll: 'सर्व',
  filterCredit: 'क्रेडिट',
  filterDebit: 'डेबिट',
  filterCompleted: 'पूर्ण',
  filterCancelled: 'बंद',
  filterPending: 'प्रलंबित',
  filterDisputed: 'विवादित',
  forgotPasswordChooseMethod: 'पासवर्ड रीसेटसाठी Email link किंवा SMS OTP निवडा.',
  forgotPasswordEmailDevHint: 'Local dev: API server च्या terminal मध्ये “Password reset link (development)” URL कॉपी करा.',
  forgotPasswordEmailHint: 'नोंदणीकृत Admin ईमेल टाका.',
  forgotPasswordFailed: 'रीसेट लिंक पाठवता आली नाही. पुन्हा प्रयत्न करा.',
  forgotPasswordIntro: 'नोंदणीकृत ईमेलवर सुरक्षित रीसेट लिंक पाठवली जाईल.',
  forgotPasswordInvalidEmail: 'वैध ईमेल पत्ता टाका.',
  forgotPasswordInvalidOtp: 'SMS मधला ६ अंकी OTP टाका.',
  forgotPasswordInvalidPhone: 'वैध १० अंकी मोबाईल नंबर टाका.',
  forgotPasswordLink: 'पासवर्ड विसरलात?',
  forgotPasswordOtpSentTo: 'OTP पाठवला:',
  forgotPasswordPhoneHint: 'नोंदणीकृत मोबाईल नंबर टाका. लिंक खात्यावरील ईमेलवर जाईल.',
  forgotPasswordSendOtp: 'OTP पाठवा',
  forgotPasswordSending: 'पाठवत आहे...',
  forgotPasswordSendingOtp: 'OTP पाठवत आहे...',
  forgotPasswordSmsDevHint: 'Development मध्ये OTP server log मध्ये दिसेल (Twilio SMS सेटअप नसेल तर).',
  forgotPasswordSmsFailed: 'OTP पाठवता आला नाही. पुन्हा प्रयत्न करा.',
  forgotPasswordSmsHint: 'नोंदणीकृत मोबाईल नंबर टाका. ६ अंकी OTP SMS वर येईल.',
  forgotPasswordSmsSuccess: 'खाते असल्यास, नोंदणीकृत मोबाईलवर OTP पाठवला आहे.',
  forgotPasswordSubmit: 'रीसेट लिंक पाठवा',
  forgotPasswordSuccess: 'खाते असल्यास, नोंदणीकृत ईमेलवर सूचना पाठवली आहे.',
  forgotPasswordTitle: 'पासवर्ड रीसेट करा',
  formLabel: 'फॉर्म',
  fuel: 'इंधन',
  fuelColon: 'इंधन:',
  fuelHistoryTitle: 'इंधन इतिहास',
  fuelLevel: 'इंधन पातळी',
  fuelLevelUpdate: 'फ्यूल लेव्हल अपडेट',
  fuelNotePlaceholder: 'टीप: भरले / वापरलेले इंधन...',
  fullName: 'पूर्ण नाव',
  goBook: '→ मशीन बुक करा',
  gpsLiveLabel: '🟢 GPS लाइव्ह',
  grandTotal: 'एकूण बेरीज',
  grandTotalText: 'एकूण रक्कम',
  gross: 'एकूण',
  grossBilling: 'एकूण बिलिंग',
  gst18: 'GST (१८%)',
  gstInvoice: 'GST बीजक',
  gstInvoices: 'GST इन्वॉइस',
  gstin: 'GSTIN',
  hide: 'लपवा',
  highTrend: 'HIGH ट्रेंड',
  hitsText: 'हिट्स',
  hmrHrs: 'तास',
  hmrToday: 'आजचे HMR',
  hmrTotal: 'एकूण HMR',
  home: 'होम',
  hours: 'तास',
  hrsUnit: 'तास',
  idle: 'निष्क्रिय',
  ifsc: 'IFSC',
  ignition: 'इग्निशन',
  importantInfo: 'मशीन मालकांसाठी महत्त्वाची माहिती',
  instantCost: 'त्वरित खर्च कॅल्क्युलेटर',
  invoiceNotAvailableCancelled: 'इन्व्हॉइस उपलब्ध नाही (रद्द)',
  iot: 'IoT आणि GPS',
  issueReportTitle: 'इश्यू रिपोर्ट',
  issueReportedSuccess: 'Issue यशस्वीपणे report झाला!',
  issues: 'समस्या',
  joinUsAction: 'Join Us — विनामूल्य नोंदणी',
  joinUsBanner: 'मशिनरी भाड्याने हवी आहे?',
  joinUsHint: 'नवीन ग्राहक? JCB, excavator, crane बुक करण्यासाठी विनामूल्य नोंदणी करा.',
  landingCtaApp: 'Development Express Explore करा',
  landingFeatBook: 'Book in minutes',
  landingFeatBookDesc: 'JCB, excavators, cranes — live availability.',
  landingFeatPay: 'Wallet-only payments',
  landingFeatPayDesc: 'GST invoice, transparent billing.',
  landingFeatTrack: 'Live GPS tracking',
  landingFeatTrackDesc: 'Machine location प्रत्येक तास update.',
  landingHeroLine1: 'Smarter & Simpler.',
  landingHeroLine2: 'महाराष्ट्राचे smart machinery rental.',
  landingSocialProof: 'Maharashtra मधील builders, contractors आणि fleet owners.',
  landingStatMachines: 'Machines',
  landingStatRating: 'Rating',
  landingTrustLine: 'Wallet-only · GST compliant · Secured',
  lastRefreshed: 'शेवटचा रिफ्रेश',
  live: 'लाइव्ह',
  liveBookAvail: 'बुकिंगनंतर लाइव्ह फीड उपलब्ध',
  liveCamera: '३६०° लाइव्ह कॅमेरा — बुकिंगनंतर',
  liveMachineLocation: 'लाइव्ह मशीन स्थान',
  liveText: 'लाइव्ह',
  liveTracking: 'लाइव्ह ट्रॅकिंग',
  loadMoreAlerts: 'अजून alerts लोड करा',
  loadMoreAttendance: 'अजून हजेरी लोड करा',
  loadMoreBookings: 'अजून बुकिंग लोड करा',
  loadMoreDlq: 'अजून DLQ लोड करा',
  loadMoreFuelLogs: 'अजून फ्यूल लॉग लोड करा',
  loadMoreLogs: 'अजून logs लोड करा',
  loadMoreMachines: 'अजून machines लोड करा',
  loadMoreTransactions: 'अजून transactions लोड करा',
  loadMoreUsers: 'अजून users लोड करा',
  loadedBookings: 'लोड झालेल्या बुकिंग्स',
  loadedDlqItems: 'लोड झालेले DLQ items',
  loadedFuelLogs: 'लोड झालेले फ्यूल लॉग्स',
  loadedOwnerBookings: '{count} मालक बुकिंग लोड{suffix}',
  loading: 'लोड होत आहे...',
  loadingDashboard: 'डॅशबोर्ड लोड होत आहे...',
  location: 'स्थान',
  lockConfirm: '🔒 लॉक पुष्टी करा',
  lockMachine: 'मशीन लॉक करा',
  lockWarning: 'Teltonika GPS द्वारे मशीनचे इग्निशन रिमोटली बंद होईल.',
  locked: 'लॉक',
  loginAs: 'लॉगिन करत आहात',
  loginChangeRole: 'भूमिका बदला',
  loginClientPortalSubtitle: 'बांधकाम मशिनरी बुक करण्यासाठी साइन इन',
  loginEmailHint: 'Admin लॉगिनसाठी registered email वापरा.',
  loginFailedGeneric: 'लॉगिन अयशस्वी — कृपया पुन्हा प्रयत्न करा',
  loginIAmQuestion: 'मी कोण…?',
  loginModeOtp: 'OTP Login',
  loginModePassword: 'Password',
  loginNewHereRegister: 'नवीन? नोंदणी करा',
  loginOtpDevHint: 'Development: SMS नसेल तर API server log मध्ये OTP पहा.',
  loginOtpHint: 'Registered mobile वर 6 अंकी OTP पाठवला जाईल.',
  loginOtpSentTo: 'OTP पाठवला:',
  loginOwnerPortalSubtitle: 'फ्लीट आणि नोंदणी व्यवस्थापनासाठी साइन इन',
  loginPhoneHint: 'Client, Owner आणि Operator लॉगिनसाठी registered mobile number वापरा.',
  loginPickRoleHint: 'नोंदणीकृत? भूमिका निवडा. नवीन? खाली Join Us वापरा.',
  loginPortalAdminSubtitle: 'प्लॅटफॉर्म नियंत्रण आणि मंजुरी',
  loginPortalAdminTitle: 'अॅडमिन पोर्टल',
  loginPortalClientSubtitle: 'बांधकाम मशिनरी बुक करण्यासाठी साइन इन',
  loginPortalClientTitle: 'ग्राहक पोर्टल',
  loginPortalOperatorSubtitle: 'नियुक्त मशीन आणि दैनिक लॉगसाठी साइन इन',
  loginPortalOperatorTitle: 'ऑपरेटर पोर्टल',
  loginPortalOwnerSubtitle: 'फ्लीट आणि नोंदणी व्यवस्थापित करण्यासाठी साइन इन',
  loginPortalOwnerTitle: 'मालक पोर्टल',
  loginRoleAdminDesc: 'प्लॅटफॉर्म नियंत्रण, मंजुरी आणि ऑपरेशन्स',
  loginRoleClientDesc: 'बांधकाम प्रकल्पांसाठी मशिनरी बुक करा',
  loginRoleClientShort: 'ग्राहक',
  loginRoleOperatorDesc: 'नियुक्त मशीन आणि दैनिक लॉग',
  loginRoleOwnerDesc: 'फ्लीट, कमाई आणि उपलब्धता व्यवस्थापित करा',
  loginRoleOwnerShort: 'मालक',
  loginSendOtp: 'OTP पाठवा',
  loginSendingOtp: 'OTP पाठवत आहे...',
  loginSignInShort: 'साइन इन',
  loginTabOtp: 'OTP',
  loginTabPassword: 'पासवर्ड',
  loginVerifyOtp: 'Verify & Sign In',
  loginVerifyingOtp: 'Verify होत आहे...',
  logout: 'लॉगआउट',
  sessionRevokedAlert: 'तुमी दुसऱ्या डिव्हाइसाचेर लॉग इन आसात. उपकार करून परत लॉगिन करात.',
  machine: 'मशीन',
  machineDefaultLabel: 'मशीन',
  machineDetails: 'मशीन आणि ऑपरेटर तपशील',
  machineDetailsTitle: 'मशीन तपशील',
  machineDispatchedAt: 'मशीन पाठवली — {when}',
  machineHours: 'मशीन तास',
  machineIdLabel: 'मशीन ID',
  machineInfo: 'मशीनची माहिती',
  machineLabel: 'मशीन',
  machineLog: 'मशीन लॉग',
  machineReg: 'मशीन नोंदणी फॉर्म',
  machineRegistrationSubmitted: 'मशीन नोंदणी सबमिट झाली! DE टीम 24 तासांत verify करेल.',
  machineRegistrationTitle: 'मशीन नोंदणी',
  machineStatus: 'मशीन स्थिती',
  machineStatusTitle: 'मशीन स्थिती',
  machines: 'मशीन्स',
  marketingBackHome: 'वेबसाइट मुखपृष्ठ',
  marketingBadge: 'लाइव ऑपरेशन्स · कराड, सातारा',
  marketingBuiltFor: 'अचूकता, अनुपालन आणि वेग हवा असलेल्या भारतीय बांधकाम संघांसाठी.',
  marketingCtaBook: 'मशीन बुक करा',
  marketingCtaLogin: 'Development Express उघडा — लॉगिन',
  marketingCtaWhatsApp: 'WhatsApp',
  marketingFooterRights: '२०२६ डेव्हलपमेंट एक्सप्रेस · कराड, सातारा',
  marketingHeadline: 'महाराष्ट्रातील अग्रगण्य मशीनरी भाडे प्लॅटफॉर्म',
  marketingLead: 'रिअल-टाइम GPS, डिजिटल वॉलेट देयके आणि बांधकाम मशीनरीसाठी स्वयंचलित ऑपरेशन्स. २०११ पासून सेवेत.',
  marketingNavContact: 'संपर्क',
  marketingNavLogin: 'प्लॅटफॉर्म लॉगिन →',
  marketingNavServices: 'सेवा',
  marketingNavTech: 'तंत्रज्ञान',
  marketingServicesTitle: 'आम्ही काय देतो',
  marketingStatDigital: 'डिजिटल देयके',
  marketingStatFleet: 'लाइव्ह मशीन',
  marketingStatYears: 'वर्षे अनुभव',
  marketingSvcOps: 'पूर्ण ऑपरेशन्स',
  marketingSvcOpsSub: 'मालक, ऑपरेटर, ग्राहक — एकच प्लॅटफॉर्म.',
  marketingSvcPay: 'फक्त वॉलेट पेमेंट',
  marketingSvcPaySub: 'GST बीजक — साइटवर रोख नाही.',
  marketingSvcTrack: 'GPS आणि लाइव्ह स्थिती',
  marketingSvcTrackSub: 'Teltonika शी जोडलेली फ्लीट दृश्यता.',
  marketingTechLead: 'Development Express बुकिंग, अनुपालन आणि फील्ड टेलिमेट्री एकाच वर्कफ्लोमध्ये जोडते.',
  md: 'MD',
  mediumTrend: 'MEDIUM ट्रेंड',
  minAdvanceRequired: 'किमान अग्रिम आवश्यक',
  minimumAdvance: 'किमान अग्रिम आवश्यक',
  minimumRecharge: 'UPI/कार्ड/QR साठी किमान ₹1.',
  moUnit: 'महिने',
  mobileNumber: 'मोबाईल नंबर',
  monthMachineSummary: 'या महिन्यातील मशीन',
  monthTotalLabel: 'महिन्याचे एकूण',
  months: 'महिने',
  moreAvailable: 'अजून उपलब्ध',
  myBookings: 'म्हज्यो बुकिंग',
  myClientRating: 'माझी ग्राहक रेटिंग',
  myMachines: 'माझ्या मशीन',
  neftRtgs: 'NEFT/RTGS',
  netEarnedMonth: 'नेट कमाई (महिना)',
  netPaid: 'नेट भरले',
  netPayable: 'निव्वळ देय',
  netReceived: 'नेट प्राप्त',
  netReceivedCaps: 'नेट प्राप्त',
  neverText: 'कधीच नाही',
  newBooking: 'नवीन बुकिंग',
  newClientRegister: 'नवीन ग्राहक? येथे नोंदणी करा',
  newClientRegistration: 'नवीन ग्राहक नोंदणी',
  newPassword: 'नवीन पासवर्ड',
  nextText: 'पुढे',
  noAlerts: 'कोणती सूचना नाही!',
  noAlertsNow: 'सध्या अलर्ट नाहीत.',
  noBankRefund: '❌ बँक परतावा नाही — फक्त वॉलेट क्रेडिट',
  noBookings: 'कोणतीही सक्रिय बुकिंग नाही',
  noBookingsAccount: 'या खात्यासाठी अजून बुकिंग नाही.',
  noBookingsYet: 'अजून बुकिंग नाही',
  noClientFeedbackYet: 'अजून ग्राहक रेटिंग नाही. डिस्पॅच नंतर ग्राहक फीडबॅक येथे दिसेल.',
  noDlqItems: 'DLQ items नाहीत',
  noFileSelected: 'फाइल निवडलेली नाही',
  noMachinesDashboard: 'अजून मशीन नाही. फ्लीट जोडण्यासाठी मशीन नोंदणी करा.',
  noMachinesTrack: 'ट्रॅक करण्यासाठी मशीन नाही',
  noMachinesTrackHint: 'GPS ट्रॅकिंगसाठी मशीन नोंदणी करा.',
  noMachinesYet: 'अजून मशीन नोंदणी झालेली नाही',
  noMoreAuditLogs: 'सध्याच्या filters साठी आणखी audit logs नाहीत.',
  noRecentApiSloBreach: 'अलीकडे API SLO breach सिग्नल नाहीत.',
  noRecentFailedLogins: 'अलीकडे failed login प्रयत्न नाहीत.',
  noRefund: 'परतावा नाही नीती',
  noSecuritySignalsFound: 'सुरक्षा सिग्नल्स सापडले नाहीत.',
  noTransactionsFilter: 'निवडलेल्या फिल्टरसाठी व्यवहार नाहीत.',
  normalText: 'नॉर्मल',
  off: 'बंद',
  officeLabel: 'ऑफिस',
  on: 'चालू',
  operator: 'ऑपरेटर',
  operatorFeedbackColumn: 'ऑपरेटर फीडबॅक',
  operatorFeedbackSaved: 'धन्यवाद! तुमचा फीडबॅक जतन झाला.',
  operatorFeedbackSubmitted: 'तुमचा फीडबॅक',
  operatorFeedbackTitle: 'ऑपरेटर फीडबॅक',
  operatorPortal: 'ऑपरेटर पोर्टल',
  operatorRole: 'ऑपरेटर',
  operatorSatisfactionQuestion: 'ऑपरेटरच्या कामाने तुम्ही समाधानी आहात का?',
  operatorSuggestionPlaceholder: 'सूचना किंवा फीडबॅक (पर्यायी)',
  operators: 'ऑपरेटर',
  optionalLabel: '(ऐच्छिक)',
  otpCode: 'OTP कोड',
  overview: 'आढावा',
  ownerBookingsAllLoaded: ' (सर्व लोड)',
  ownerBookingsMoreAvailable: ' (अजून उपलब्ध)',
  ownerInfo: 'मालकाची माहिती',
  ownerPortal: 'मालक पोर्टल',
  ownerRole: 'मशीन मालक',
  owners: 'मालक',
  password: 'पासवर्ड',
  passwordsMustMatch: 'दोन्ही पासवर्ड एकसारखे असावेत.',
  pastIssuesTitle: 'मागील इश्यूज',
  payNow: 'आता पैसे द्या',
  payNowText: 'आता पेमेंट करा',
  paymentBreakdownTitle: 'पेमेंट तपशील — एप्रिल 2026',
  paymentCycle: 'पेमेंट चक्र',
  paymentFailed: 'Payment अयशस्वी! पुन्हा प्रयत्न करा.',
  paymentHistory: 'देयक इतिहास',
  paymentHistoryTitle: 'पेमेंट इतिहास',
  paymentMethods: 'देयक पद्धती',
  paymentMode: 'पेमेंट मोड',
  paymentSuccess: 'Payment यशस्वी!',
  pdfInvoiceFailed: 'इन्व्हॉइस PDF तयार करता आला नाही. पुन्हा प्रयत्न करा.',
  pdfReportFailed: 'अहवाल PDF तयार करता आला नाही. पुन्हा प्रयत्न करा.',
  pdiCompleted: '✅ PDI / सुरक्षा तपासणी पूर्ण',
  pdiCrawlerHint: 'क्रॉलर: प्रदूषण (PUC) लागत नाही — RTO नोंदणी नाही.',
  pdiInfo: 'PDI तपासणी',
  pdiInsuranceApplicable: '✅ विमा / कव्हर (लागू असल्यास)',
  pdiInsuranceValid: '✅ विमा वैध आणि अद्ययावत',
  pdiPollutionValid: '✅ प्रदूषण प्रमाणपत्र (PUC) वैध',
  pdiTitle: 'प्री-डिलिव्हरी तपासणी (PDI)',
  penaltyDeduct: 'रद्दीकरण दंड (१ तास)',
  pending: 'प्रलंबित',
  pendingApproval: 'मंजुरी प्रलंबित',
  pendingCount: '{count} प्रलंबित',
  pendingDispatch: 'डिस्पॅच प्रलंबित',
  perDay: 'प्रति दिवस',
  perHour: 'प्रति तास',
  perMonth: 'प्रति महिना',
  perWeek: 'प्रति आठवडा',
  phone: 'फोन',
  platform: 'बांधकाम व्यवस्थापन व्यासपीठ',
  platformAgreement: 'प्लॅटफॉर्म करार',
  policyLabel: 'धोरण',
  policyTopicBooking: 'बुकिंग',
  policyTopicCancellation: 'रद्दीकरण',
  policyTopicContact: 'संपर्क',
  policyTopicGst: 'GST',
  policyTopicHours: 'सपोर्ट वेळ',
  portalBackLink: 'पोर्टल',
  portalClient: 'ग्राहक',
  portalClientSub: 'मशिनरी बुक करा',
  portalNewClientRegister: 'नवीन ग्राहक? नोंदणी',
  portalNewOwnerRegister: 'नवीन मालक? नोंदणी',
  portalOwner: 'मालक',
  portalOwnerSub: 'फ्लीट व्यवस्थापन',
  portalStaffAdmin: 'ॲडमिन',
  portalStaffOperator: 'ऑपरेटर',
  portalWelcome: 'स्वागत',
  portalWelcomeHint: 'पुढे जाण्यासाठी तुमचा पोर्टल निवडा',
  quantityLabel: 'प्रमाण',
  quickIssueReport: 'क्विक इश्यू रिपोर्ट',
  quickRechargeUpi: 'UPI द्वारे जलद रिचार्ज',
  quickSelect: 'जलद निवड:',
  rateCard: 'दर पत्रक (ऑपरेटरसह)',
  rateLimitTelemetryTitle: 'रेट लिमिट टेलिमेट्री',
  rateOperatorWork: 'ऑपरेटरचे काम रेट करा (1–5 तारे)',
  rating: 'रेटिंग',
  receiptId: 'पावती ID',
  recentAlerts: 'अलीकडील सूचना',
  recentFailedLoginsTitle: 'अलीकडील failed logins',
  recentLabel: 'अलीकडील',
  recharge: 'रिचार्ज',
  rechargeFirst: '⚡ आधी वॉलेट रिचार्ज करा',
  rechargeWallet: '+ वॉलेट रिचार्ज',
  ref: 'संदर्भ क्रमांक',
  refreshText: 'रिफ्रेश',
  refreshingText: 'रिफ्रेश होत आहे...',
  regCapacitySpecs: 'क्षमता / तपशील',
  regDocCrawlerHint: 'क्रॉलर: चेसिस प्लेट, खरेदी इन्वॉइस, फोटो आणि ID. विमा ऐच्छिक.',
  regDocWheeledHint: 'व्हील्ड: RC (RTO), विमा, PUC आणि ID (जास्तीत जास्त 5MB).',
  regEquipmentCategory: 'उपकरणाचा प्रकार *',
  regFailed: 'नोंदणी अयशस्वी. पुन्हा प्रयत्न करा.',
  regFileSizeError: 'प्रत्येक दस्तावेज जास्तीत जास्त 5MB',
  regFileTypeError: 'फक्त PDF, JPG, PNG किंवा WEBP परवानगी',
  regFleetIdOptional: 'Fleet / chassis ID (ऐच्छिक)',
  regMachineCategory: 'मशीन प्रकार *',
  regMachineInfoTitle: 'मशीन माहिती',
  regMachineIntro: 'फक्त बांधकाम heavy equipment — truck/transport नाही. Wheeled (JCB 3DX) साठी RTO; Crawler (Poclain/excavator) साइटवर — RTO passing नाही.',
  regMachineNameModel: 'मशीन नाव / मॉडेल',
  regMobilityTracked: 'क्रॉलर (चेन)',
  regMobilityTrackedHint: 'Poclain (chain excavator), dozer — साइटवर, RTO passing नाही',
  regMobilityWheeled: 'व्हील्ड (चाकांवर)',
  regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — बांधकाम उपकरण, RTO (RC) लागते',
  machineFinancialSection: 'मशीन खरेदी तपशील (ऐच्छिक)',
  machineOwnershipType: 'मालकी प्रकार',
  machineOwnershipNew: 'नवीन मशीन',
  machineOwnershipUsed: 'मूळ मालक',
  machineOwnershipSecondHand: 'पूर्व-मालकी',
  machinePurchasePrice: 'खरेदी किंमत (₹)',
  machinePurchasePriceHint: 'या मशीनसाठी तुम्ही भरलेली रक्कम',
  machinePurchaseDate: 'खरेदी तारीख',
  machineYearOfManufacture: 'उत्पादन वर्ष',
  machineLoanSection: 'या मशीनवर माझे loan आहे',
  machineLoanAmount: 'Loan रक्कम (₹)',
  machineLoanEmi: 'मासिक EMI (₹)',
  machineLoanTenure: 'Loan कालावधी (महिने)',
  machineLoanStartDate: 'Loan सुरू तारीख',
  machineFuelConsumption: 'इंधन वापर (L/hr)',
  machineMonthlyOperatingExpenses: 'मासिक परिचालन खर्च',
  machineOperatorMonthlySalary: 'ऑपरेटर मासिक पगार',
  machineServiceMonthly: 'सर्व्हिस / देखभाल (मासिक)',
  machineBreakdownMonthly: 'बिघाड / दुरुस्ती (मासिक सरासरी)',
  machineMaterialsMonthly: 'साहित्य / उपभोग्य (मासिक)',
  recoveryPlan: 'रिकवरी प्लान',
  recoveryOnTrack: 'योग्य मार्गाचेर',
  recoveryNeedsAttention: 'लक्ष दिवपाक जाय',
  recoveryActionRequired: 'कार्यावळी गरजेची',
  recoveryAddPrice: 'रिकवरी प्लान पळोवपाक खरेदी किंमत जोडात',
  recoveryProgress: 'गुंतवणूक परतफेड',
  recoveryDailyNet: 'दिसाळें निव्वळ उत्पन्न',
  recoveryDays: 'परतावो कालावधी',
  recoveryProjectedDate: 'अपेक्षित परतावो तारीख',
  recoveryRoi: 'वार्षिक परतावो',
  recoveryCurrentValue: 'सद्याचें यंत्र मूल्य',
  editFinancialDetails: 'आर्थिक तपशील संपादित करात',
  financialDetailsSaved: 'आर्थिक तपशील जतन केले',
  recoveryBackfillNudge: 'रिकवरी ट्रॅकिंग अनलॉक करपाक {{count}} मशीन(ां)क खरेदी तपशील जोडात',
  dieselPriceTitle: 'डिझेल किंमत',
  dieselPriceUpdate: 'डिझेल किंमत अपडेट करात',
  dieselPriceLatest: 'नवीनतम किंमत',
  dieselPriceNoRecord: 'डिझेल किंमत नोंद ना',
  dieselPricePerLitre: 'प्रति लिटर किंमत (₹)',
  dieselQuantity: 'भरलेली मात्रा (लिटर)',
  dieselTaluka: 'शहर / भाग',
  bookingAttachment: 'अटॅचमेंट निवडात',
  bookingAttachmentNone: 'खास अटॅचमेंट ना',
  bookingWorkDescription: 'कामाचें वर्णन',
  bookingWorkDescriptionPlaceholder: 'उदा. पाया खोदप, ट्रेंचिंग, पाइपलाइन काम',
  bookingAttachmentLabel: 'अटॅचमेंट',
  bookingSiteLabel: 'साइट',
  bookingWorkLabel: 'काम',
  termsAccept: "हांव अटी आनी शर्तींक मान्यता दितां",
  termsRequired: "नोंदणी खातीर अटी आनी शर्ती मान्य करपाक जाय",
  termsLink: "अटी आनी शर्ती",
  clientBlacklisted: "ब्लॅकलिस्ट",
  clientBlacklistReason: "ब्लॅकलिस्टाचें कारण",
  clientBlacklistConfirm: "ह्या क्लायंटाक ब्लॅकलिस्ट करचें?",
  clientUnblacklist: "ब्लॅकलिस्टांतल्यान काडात",
  blacklistedClients: "ब्लॅकलिस्ट क्लायंट",
  blacklistedClientsEmpty: "ब्लॅकलिस्ट क्लायंट नात",
  managerAccessRestricted: "वित्त प्रवेश प्रतिबंधित. ओम चव्हाण हांकां संपर्क करात.",
  managerSection: "मॅनेजर",
  managerAdd: "मॅनेजर जोडात",
  managerName: "मॅनेजराचें नांव",
  managerEmail: "मॅनेजर ईमेल",
  managerPassword: "तात्पुरतो पासवर्ड",
  managerCreated: "मॅनेजर खातें तयार जालें",
  managerCredentialsTitle: "मॅनेजर लॉगीन तपशील",
  managerCredentialsSubtitle: "हे तपशील आतां सांबाळात — पासवर्ड फुडें परत मेळचो ना",
  managerCredentialsSaved: "हांवें तपशील सांबाळ्ल्यात",
  managerLoginUrl: "लॉगीन URL",
  managerActivity: "मॅनेजर कृती",
  managerActivityEmpty: "आतांमेरेन खंयचीच कृती नोंदिल्ली ना",
  managerActivityViewAll: "सगळ्यो कृती पळयात",
  onboardingTitle: "सुरवात करात",
  onboardingAccountApproved: "खातें मंजूर",
  onboardingKycComplete: "KYC तपासणी पूर्ण",
  onboardingKycPending: "KYC तपासणी पूर्ण करात",
  onboardingKycRejected: "KYC नाकारले — परत सबमिट करात",
  onboardingWalletFunded: "वॉलेटांत रक्कम आसा",
  onboardingWalletEmpty: "बुकिंगा खातीर वॉलेटांत रक्कम घालात",
  pushEnablePrompt: "त्वरित अपडेटां खातीर पुश सूचना सुरू करात",
  downloadDisputeStatement: "वाद निवेदन डाउनलोड करा",
  downloadInvoice: "इनव्हॉइस डाउनलोड करा",
  bookAgain: "परत बुक करा",
  machineNoLongerAvailable: "मशीन आता उपलब्ध ना",
  downloadHistoryPdf: "इतिहास PDF डाउनलोड करा",
  onboardingFirstBooking: "तुमची पयली बुकिंग करात",
  onboardingAllDone: "तुमी तयार आसात!",
  onboardingTrackerTitle: "ऑनबोर्डिंग प्रगती",
  onboardingTrackerTarget: "ऑनबोर्डिंग लक्ष्य: 48 वरां",
  onboardingTrackerInProgress: "प्रगतींत",
  onboardingTrackerActionRequired: "कारवाई गरजेची",
  onboardingTrackerComplete: "पूर्ण",
  onboardingTrackerPending: "प्रलंबित",
  onboardingTrackerPhase1: "नोंदणी",
  onboardingTrackerPhase2: "KYC तपासणी",
  onboardingTrackerPhase3: "मशीन नोंदणी",
  onboardingTrackerPhase4: "पयली बुकिंग तयार",
  onboardingTrackerHelper1: "मशीन नोंदणी उगडपाक आधार + सेल्फी अपलोड करात",
  onboardingTrackerHelper2: "KYC तपासणींत — सादारणपणान 24 वरांनी",
  onboardingTrackerHelper3: "KYC नाकारले — कागदपत्र परत सबमिट करात",
  onboardingTrackerHelper4: "KYC मंजूर — तुमची पयली मशीन घालात",
  onboardingTrackerHelper5: "मशीन अॅडमीन तपासणींत",
  onboardingTrackerHelper6: "मशीन लाइव — पयल्या बुकिंगाची वाट",
  onboardingTrackerPhaseLabel: "टप्पो",
  alertsAndNotifications: 'अलर्ट आनी अधिसूचना',
  dieselFuelCostPerHour: 'प्रति तास इंधन खर्च',
  dieselPercentOfRate: 'तुमच्या तासाच्या दराचो',
  dieselPriceSaved: 'डिझेल किंमत जतन केली',
  dieselRateSuggestion: 'दर सूचना',
  dieselRateIncrease: 'डिझेल वाडले — दर वाडोवपाचो विचार करात',
  dieselRateDecrease: 'डिझेल कमी — बुकिंगाक लागी दर कमी करात',
  dieselSuggestedRate: 'सुचवलेली दर',
  dieselHistory: 'किंमत इतिहास',
  dieselNoHistory: 'अद्याप डिझेल किंमत इतिहास ना',
  dieselColDate: 'तारीख',
  dieselColPrice: 'किंमत/लिटर',
  dieselColQty: 'प्रमाण',
  dieselColSource: 'स्रोत',
  dieselUploadReceipt: 'पावती अपलोड करा',
  dieselExtractSuccess: 'पावतीवरून काढले',
  dieselExtractFailed: 'काढता आले नाही — कृपया स्वहस्ते प्रविष्ट करा',
  applyRateSuggestion: '₹{{rate}}/तास लागू करा',
  rateSuggestionApplied: 'दर यशस्वीरित्या अपडेट झाली',
  marketPosition: 'बाजार स्थिती',
  marketBelowMarket: 'बाजारपेक्षा कमी',
  marketCompetitive: 'स्पर्धात्मक',
  marketAboveMarket: 'बाजारपेक्षा जास्त',
  marketNoData: 'तुमच्या भागासाठी अद्याप बाजार डेटा नाही',
  marketSubmitRate: 'बाजार दर सादर करा',
  marketCity: 'शहर / भाग',
  marketMinRate: 'तुमच्या भागात किमान दर (₹/तास)',
  marketMaxRate: 'तुमच्या भागात कमाल दर (₹/तास)',
  marketRateSubmitted: 'बाजार दर सादर झाली — धन्यवाद!',
  marketDataPoints: '{{count}} सादरांवर आधारित',
  marketRange: '{{city}} मध्ये बाजार',
  marketSourceLocal: '{{city}} भागातल्या दरांचेर आधारित',
  marketSourcePlatform: 'प्लॅटफॉर्म-व्यापी दरांचेर आधारित',
  regPremiumOnboarding: 'प्रीमियम ऑनबोर्डिंग',
  regRtoNumber: 'RTO नोंदणी क्रमांक *',
  regSelectType: 'प्रकार निवडा…',
  regSubmitBtn: '✅ नोंदणी सबमिट करा',
  regTagNoRto: 'RTO नाही',
  regTagRto: 'RTO',
  regYearManufacture: 'उत्पादन वर्ष *',
  register: 'मशीन नोंदणी',
  registerAction: 'नोंदणी करा',
  registerMachine: 'मशीन नोंदणी',
  registering: 'नोंदणी सुरू आहे...',
  registrationPending: 'Admin तुमचे account 24 तासांच्या आत activate करेल.',
  registrationSuccess: 'नोंदणी यशस्वी!',
  remoteLockAlert: 'Teltonika GPS बसवल्यानंतर रिमोट लॉक सक्षम होईल. DE सपोर्टशी संपर्क करा.',
  remoteLockMachine: '🔒 रिमोट लॉक मशीन',
  replaceFile: 'बदला',
  reportText: 'रिपोर्ट',
  reports: 'अहवाल',
  resetMethodEmail: 'Email link',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'पासवर्ड बदलता आला नाही. नवीन लिंक मागवा.',
  resetPasswordIntro: 'किमान ८ अक्षरांचा मजबूत पासवर्ड निवडा.',
  resetPasswordMinLength: 'पासवर्ड किमान ८ अक्षरे असावा.',
  resetPasswordMissingToken: 'रीसेट लिंक चुकीची आहे. लॉगिनवरून Forgot password वापरा.',
  resetPasswordSubmit: 'पासवर्ड अपडेट करा',
  resetPasswordSuccess: 'पासवर्ड बदलला. लॉगिनकडे जात आहे...',
  resetPasswordTitle: 'नवीन पासवर्ड ठेवा',
  resetPasswordUpdating: 'अपडेट होत आहे...',
  resetText: 'रीसेट',
  retryDlqItemTitle: 'DLQ आयटम पुन्हा प्रयत्न',
  retryFailedForDlq: 'DLQ आयटमसाठी पुन्हा प्रयत्न अयशस्वी',
  retryReasonAuditPlaceholder: 'पुन्हा प्रयत्न कारण (ऑडिटसाठी)',
  retryText: 'पुन्हा प्रयत्न',
  revenue: 'उत्पन्न',
  running: 'चालू',
  satisfiedNo: 'समाधानी नाही',
  satisfiedYes: 'होय, समाधानी',
  save: 'जतन करा',
  scanToPay: 'पेमेंटसाठी स्कॅन करा',
  scheduleColFeedback: 'फीडबॅक',
  scheduleColQty: 'Qty',
  scheduleColTotal: 'एकूण',
  scheduleColType: 'प्रकार',
  securitySignalsTitle: 'सुरक्षा सिग्नल्स',
  selectBook: 'ही मशीन बुक करा →',
  selectCalc: '📋 निवडा आणि खर्च बघा →',
  selectFile: 'फाइल निवडा',
  selectMachineFirst: 'आधी मशीन निवडा',
  selectQty: 'प्रमाण निवडा',
  selectRole: 'भूमिका निवडात',
  selectedMachineText: 'निवडलेली मशीन',
  send: 'पाठवा',
  sendEmail: 'ईमेल पाठवा',
  sendWhatsapp: 'WhatsApp वर पाठवा',
  settlements: 'सेटलमेंट',
  show: 'दाखवा',
  signIn: 'साइन इन',
  signingIn: 'लॉगिन जाता...',
  signupCompanyName: 'कंपनीचे नाव',
  signupContactName: 'संपर्क नाव',
  signupCreatePassword: 'पासवर्ड तयार करा',
  signupReenterPassword: 'पासवर्ड पुन्हा टाका',
  signupSectionCompany: 'कंपनी',
  signupSectionContact: 'तुमची माहिती',
  signupSectionSecurity: 'सुरक्षा',
  sinceExcellence: '2011 पासून · 15 वर्षे उत्कृष्टता',
  sinceLabel: 'पासून',
  sloBreachRisk: 'SLO breach धोका',
  sloHealthy: 'SLO हेल्दी',
  speed: 'वेग',
  staleText: 'जुने',
  status: 'स्थिती',
  statusCancelled: 'रद्द',
  bookingClosed: 'बंद',
  sectionNew: 'नवे',
  sectionAccepted: 'स्वीकृत',
  sectionActive: 'सक्रिय',
  sectionDispatched: 'डिस्पॅच',
  sectionCompleting: 'पूर्ण जाता',
  sectionDisputed: 'विवादित',
  sectionCompleted: 'पूर्ण',
  sectionClosed: 'बंद',
  statusCompleted: 'पूर्ण',
  stopped: 'बंद',
  submit: 'सबमिट करा',
  submitOperatorFeedback: 'फीडबॅक पाठवा',
  submittedRegistrations: 'सबमिट केलेली नोंदणी',
  support: 'मदत',
  supportPolicyBooking: 'फक्त वॉलेट अग्रिम. साइटवर रोख नाही.',
  supportPolicyCancellation: '१ तास दंड; शिल्लक वॉलेटमध्ये.',
  supportPolicyContact: 'फक्त DE सपोर्ट — थेट ऑपरेटर संपर्क निषिद्ध.',
  supportPolicyGst: 'सर्व इन्व्हॉइसवर १८% GST; अहवाल टॅबवरून डाउनलोड.',
  supportPolicyHours: 'सोम–शनि, ९ ते ७ IST',
  tableAtt: 'अट',
  tableChange: 'बदल',
  tableDay: 'दिवस',
  tableEnd: 'समाप्त',
  tableHrs: 'तास',
  tableId: 'आयडी',
  tableIn: 'इन',
  tableLevel: 'लेव्हल',
  tableMonth: 'महिना',
  tableNote: 'नोट',
  tableOut: 'आउट',
  tableStart: 'सुरू',
  tagline: 'पायाभूत सुविधेचो सोन्यो दर्जो',
  tax: 'कर',
  tdsGstTcs: 'TDS 2% + GST TCS 1%',
  tdsTcs: 'TDS+TCS',
  termCommission: 'Development Express कमिशन: एकूण बिलिंगचे 15%',
  termFuel: 'मशीनमध्ये नेहमी 40%+ इंधन ठेवा',
  termGps: 'GPS (Teltonika) अनिवार्य — DE द्वारे बसवले',
  termGstTcs: 'GST TCS: GST नियमांनुसार 1%',
  termNoDirectContact: 'थेट ग्राहक संपर्क = त्वरित करार रद्द',
  termPaymentDays: 'ग्राहक सेटलमेंटनंतर 3 कार्य दिवसांत पेमेंट',
  termTds: 'TDS कपात: आयकर कायद्यानुसार 2%',
  threeWorkingDays: '3 कार्य दिवस',
  timeLabel: 'वेळ',
  todayText: 'आज',
  topSourceIp: 'टॉप सोर्स IP',
  total: 'एकूण',
  totalAdvanceLabel: 'अग्रिम भरले',
  totalBookingsText: 'एकूण बुकिंग्स',
  totalMachines: 'एकूण मशीन',
  totalSpent: 'एकूण खर्च',
  tracking: 'GPS ट्रॅकिंग',
  transactionHistoryTitle: 'व्यवहार इतिहास',
  transactions: 'व्यवहार इतिहास',
  trustStatCompliant: 'अनुपालन',
  trustStatMachines: 'मशीन',
  trustStatRating: 'रेटिंग',
  txnDescription: 'वर्णन',
  type: 'प्रकार',
  understood: '✅ समजले — प्लॅटफॉर्म वापरेन',
  understoodAction: 'समजले',
  unknownText: 'अज्ञात',
  updateFuel: 'फ्यूल अपडेट करा',
  updateText: 'अपडेट करा',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  uploadFile: 'अपलोड',
  valEmail: 'वैध ईमेल आवश्यक',
  valMachineName: 'मशीन नाव / मॉडेल आवश्यक',
  valMachineType: 'उपकरण श्रेणी निवडा',
  valMobility: 'व्हील्ड किंवा क्रॉलर उपकरण प्रकार निवडा',
  valOwnerName: 'मालकाचे नाव आवश्यक',
  valPdiChecks: 'सर्व आवश्यक तपासण्या पुष्टी करा',
  valPdiRequired: 'PDI पुष्टी आवश्यक',
  valPhone: 'वैध फोन नंबर आवश्यक',
  valRto: 'व्हील्ड मशीनसाठी RTO नंबर आवश्यक',
  valUploadMissing: 'अपलोड करा: {docs}',
  valYear: 'वैध वर्ष (YYYY) आवश्यक',
  viewMachines: '→ मशीन बघा',
  wallet: 'वॉलेट',
  walletBalance: 'वॉलेट शिल्लक',
  walletCredit: 'वॉलेट क्रेडिट',
  walletDebit: 'वॉलेट डेबिट',
  walletDeduct: '50% अग्रिम वॉलेटमधून · रोख नाही · काम पूर्ण झाल्यावर GST बीजक',
  walletInsufficient: '❌ अपुरी शिल्लक',
  walletLowRecharge: 'वॉलेट शिल्लक कमी — पुढील बुकिंगपूर्वी रिचार्ज करा',
  walletOnly: 'फकत वॉलेट · रोख मान्य ना',
  walletOnlyPolicyDesc: 'सर्व व्यवहार फक्त वॉलेटद्वारे. रोख स्वीकारले जाणार नाही.',
  walletOnlyPolicyTitle: 'फक्त वॉलेट धोरण',
  walletRechargeTitle: 'वॉलेट रिचार्ज',
  walletSufficient: '✅ पुढे जा',
  weeks: 'आठवडे',
  whatsapp: 'WhatsApp',
  wksUnit: 'आठवडे',
  year: 'वर्ष',
  yearsExperience: '{n} वर्षे',
  yourMessage: 'तुमचा प्रश्न किंवा अडचण लिहा...',
  // --- Recent feature strings ---
  retryLabel: 'परत प्रयत्न करात',
  payrollPreview: 'पगार पूर्वावलोकन',
  payrollRun: 'पगार चालवात',
  payrollAlreadyRun: 'ह्या म्हयनाक पगार आदींच चालवला',
  payrollGross: 'एकूण देय',
  payrollNet: 'निव्वळ देय',
  payrollAdvanceDeducted: 'अग्रिम वजावट',
  payrollRunSuccess: 'पगार यशस्वी',
  payrollNoAmount: 'ह्या म्हयनाक देय रक्कम ना',
  payrollMonth: 'पगार म्हयनो',
  exportPayrollCsv: 'पगार CSV निर्यात',
  payrollExportMonth: 'पगार निर्यात म्हयनो',
  payrollDailyRate: 'दैनिक दर',
  payrollHistory: 'पगार इतिहास',
  payrollNoHistory: 'अजून कोणो पगार चालूं ना',
  payrollColMonth: 'म्हयनो',
  payrollColGross: 'एकूण',
  payrollColDeduction: 'अग्रिम वजावट',
  payrollColNet: 'निव्वळ पगार',
  payrollColDate: 'तारीख',
  downloadPayslip: 'पे स्लिप डाउनलोड',
  payslipTitle: 'मासिक पे स्लिप',
  payslipEarnings: 'उत्पन्न',
  payslipDeductions: 'वजावट',
  payslipDaysWorked: 'कामाचे दिवस',
  payslipGeneratedBy: 'Development Express द्वारे तयार',
  operatorPayrollTitle: 'मजो पगार',
  payrollMonthlySalary: 'मासिक पगार',
  payrollCurrentMonth: 'सध्या म्हयनो',
  payrollPreviousMonth: 'फाटलो म्हयनो',
  ownerAttendanceTitle: 'हाजेरी',
  ownerAttendanceEdit: 'संपादन',
  ownerAttendanceSave: 'सेव',
  ownerAttendanceNoRecords: 'ह्या म्हयन्याक हाजेरी नोंद ना',
  ownerAttendanceOverrideSuccess: 'हाजेरी अपडेट जाली',
  ownerSalaryUpdated: 'पगार यशस्वीरित्या अपडेट जाला',
  ownerSalaryEditBtn: 'पगार संपादन',
  ownerSalaryNotSet: 'पगार सेट ना — पगार चालवपाक पगार सेट करात',
  duration: "काळ",
  durationLabel: 'काळ',
  plQuotaLabel: 'PL कोटा',
  plUsed: 'वापरले',
  plAllowed: 'मान्य',
  plRemaining: 'उरले',
  plQuotaUpdated: 'PL कोटा अपडेट',
  plQuotaExhausted: 'PL कोटा संपला — बिनपगारी सुट्टी म्हणून नोंद',
  plRemainingLabel: 'उरलेले PL',
  noAttendanceRecords: 'अजून हाजेरी नोंद ना',
  noFuelLogs: 'अजून इंधन लॉग ना',
  noIssuesYet: 'अजून खंची समस्या नोंद ना',
  failedToLoad: 'डेटा लोड करप अयशस्वी',
  failedToLoadReport: 'अहवाल लोड करप अयशस्वी',
  failedToLoadIssues: 'समस्या लोड करप अयशस्वी',
  failedToLoadAlerts: 'अलर्ट लोड करप अयशस्वी',
  noRecordsMonth: 'ह्या म्हयनाक नोंद ना',
  underReview: 'पुनरावलोकनांत',
  issueResolved: 'सोडवले',
  presentDaysLabel: 'हाजीर दीस',
  halfDaysLabel: 'अर्धे दीस',
  absentDaysLabel: 'गैरहाजीर दीस',
  totalHmrLabel: 'एकूण HMR',
  noActiveBookingIdle: 'सक्रिय बुकिंग ना — मशीन निष्क्रिय',
  siteLocationNotCaptured: 'साइट स्थान नोंद जावंक ना',
  siteLocationNotAvailable: 'साइट स्थान उपलब्ध ना',
  bookingRefLabel: 'बुकिंग Ref',
  alertPendingBookings: 'बाकी बुकिंग',
  alertPendingPayouts: 'बाकी पेमेंट',
  alertLowFuel: 'कमी इंधन',
  alertOpenIssues: 'खुली समस्या',
  noMachineRunning: 'सध्या खंची मशीन चालू ना',
  trackingEmptyHint: 'मशीन धाडल्यान तुमची सक्रिय बुकिंग हांगा दिसतली.',
  trackingUpdatedEvery5s: 'दर 5 सेकंदांनी अपडेट',
  fuelLastOperatorUpdate: '(ऑपरेटराचे शेवटचे अपडेट)',
  alertExtensionPending: 'बुकिंग विस्तार प्रलंबित',
  alertConfirmCompletion: 'कृपया काम पूर्णतेची पुष्टी करात',
  alertWalletCredited: 'वॉलेटांत जोडले',
  alertFeedbackRequest: 'काम पूर्ण — तुमचो अभिप्राय सामायिक करात',
  noLogsYet: 'अजून कशीच क्रिया नोंदिली ना',
  todayActivityLog: 'आजचो क्रियाकलाप लॉग',
  machineLogSubtitle: 'इंधन, उपस्थिती, समस्या — स्थानिक सत्र लॉग',
  timerPaused: 'Timer थांबवला',
  liveBookingTitle: 'लाइव्ह बुकिंग',
  machineLogTimerHint: 'Timer Admin सुरू करतो. खाली तुमचो प्रत्यक्ष कामाचो वेळ नोंदवात — पूर्ण जाल्यार Mark Work Complete वर क्लिक करात.',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'उपस्थिती',
  ownerAlertBookingPending: 'नवी बुकिंग तुमच्या मंजुरी खातीर प्रलंबित —',
  ownerAlertBookingHours: 'तास',
  ownerAlertPayoutPending: '₹{{amount}} चे पेमेंट ट्रान्सफर प्रलंबित',
  ownerAlertFuelLow: 'इंधन कमी',
  ownerAlertFuelRemaining: 'उरले',
  ownerAlertIssue: 'समस्या नोंदल्या',
  iotGpsDevicesActive: 'GPS उपकरण सक्रिय',
  iotDashcamsOnline: 'डॅशकॅम ऑनलाइन',
  iotFuelSensorsActive: 'इंधन सेन्सर सक्रिय',
  iotMachinesLocked: 'मशीन लॉक',
  iotDeviceStatus: 'IoT उपकरण स्थिती',
  iotColMachine: 'मशीन',
  iotColGps: 'GPS',
  iotColLocation: 'स्थान',
  iotColFuel: 'इंधन %',
  iotColDashcam: 'डॅशकॅम',
  iotColIgnition: 'इग्निशन',
  iotColAction: 'कृती',
  iotStatusOnline: 'ऑनलाइन',
  iotStatusNotConnected: 'जोडलेले नाही',
  iotStatusLive: 'लाइव्ह',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'लॉक',
  iotNotConnectedBanner: 'IoT हार्डवेअर अजून स्थापित नाही. Teltonika उपकरण स्थापनेनंतर GPS, डॅशकॅम आणि रिमोट लॉक सुविधा उपलब्ध होतील.',
  fuelUpdateTitle: 'इंधन अपडेट',
  fuelSensorAccuracyNote: 'ऑपरेटरान इंधन पातळी नोंदली · मॅन्युअल नोंद',
  bookingsTab: 'बुकिंग',
  unknownLabel: 'अज्ञात',
  naLabel: 'N/A',
  baseLabel: 'आधार',
  qtyLabel: 'प्रमाण',
  actualHrsLabel: 'वास्तविक तास',
  auditStatTotal: 'एकूण',
  auditStatSecurity: 'सुरक्षा',
  auditStatActors: 'कर्ते',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'अ-Admin',
  kycDocLicense: 'परवाना',
  kycDocAadhaarFront: 'Aadhaar समोर',
  kycDocAadhaarBack: 'Aadhaar मागे',
  kycDocPoliceVerification: 'पोलीस पडताळणी',
  kycVerification: 'KYC पडताळणी',
  kycNotSubmitted: 'KYC सादर केल्लें ना',
  kycUnderReview: 'KYC पुनरावलोकनांत',
  kycVerified: 'KYC पडताळलां',
  kycRejected: 'KYC नाकारलां',
  kycAadhaarFront: 'Aadhaar समोर',
  kycAadhaarBack: 'Aadhaar मागे',
  kycSelfie: 'सेल्फी',
  kycSubmitBtn: 'KYC कागदपत्रां सादर करात',
  kycSubmitSuccess: 'कागदपत्रां सादर — पुनरावलोकनांत',
  kycResubmit: 'कागदपत्रां परत सादर करात',
  adminKycTitle: 'क्लायंट KYC पुनरावलोकन',
  adminKycAllFilter: 'सगळे',
  adminKycNoSubmissions: 'अजून KYC सादर ना',
  adminOwnerKycTitle: 'मालक KYC पुनरावलोकन',
  adminOwnerKycNoSubmissions: 'अजून कोणतेही मालक KYC सादर ना',
  adminOperatorKycTitle: 'ऑपरेटर KYC पुनरावलोकन',
  adminOperatorKycNoSubmissions: 'अजून कोणतेही ऑपरेटर KYC सादर ना',
  kycRejectedWarning: 'तुमचे KYC नाकारले. कृपया कागदपत्रे पुन्हा सादर करा.',
  kycNotSubmittedHint: 'विश्वासार्ह अनुभवासाठी KYC पूर्ण करा.',
  kycPendingHint: 'तुमचे KYC पुनरावलोकनाधीन आहे.',
  kycGoToTab: 'KYC कडे जा',
  adminKycApproveBtn: 'मंजूर',
  adminKycRejectBtn: 'नाकार',
  adminKycViewDocs: 'कागदपत्रां पळयात',
  adminKycRejectReason: 'नाकाराचें कारण',
  adminKycRereviewBtn: 'परत पुनरावलोकन',
  kycPan: 'PAN कार्ड',
  kycOwnerSubmitSuccess: 'कागदपत्रे सादर — तुमचे KYC पुनरावलोकनाधीन आसा',
  kycLicense: 'ड्रायव्हिंग परवानो',
  kycPoliceVerification: 'पोलीस पडताळणी',
  kycOperatorSubmitSuccess: 'कागदपत्रे सादर — तुमचे KYC पुनरावलोकनाधीन आसा',
  operatorKycRejectedAssign: 'ह्या ऑपरेटराचें KYC नाकारलां — पुन्हा मंजूर जावपर्यंत तांकां नियुक्त करूंक शकना.',
  operatorsColOperator: 'ऑपरेटर',
  operatorsColEmail: 'ईमेल',
  operatorsColPhone: 'फोन',
  operatorsColDocuments: 'कागदपत्रां',
  operatorsColStatus: 'स्थिती',
  operatorsDocumentsBtn: 'कागदपत्रां ({{count}})',
  operatorsNoResults: 'कोणतेही ऑपरेटर मेळूंक ना',
  operatorsAllTitle: 'सगळे ऑपरेटर ({{count}})',
  operatorsKycDialogDesc: 'KYC कागदपत्रां',
  bookingsCountLabel: '{{count}} बुकिंग',
  complianceDates: 'अनुपालन तारखो',
  complianceInsurance: 'विमा',
  complianceRcBook: 'RC बुक',
  compliancePuc: 'PUC',
  complianceNotSet: 'सेट ना',
  complianceExpired: 'कालबाह्य',
  complianceExpiringSoon: 'लवकरच कालबाह्य',
  complianceExpiringCritical: '७ दिसांत कालबाह्य',
  complianceValid: 'वैध',
  complianceUpdateBtn: 'अनुपालन तारखो अपडेट करात',
  complianceSaveBtn: 'सेव',
  complianceAlertsTitle: 'अनुपालन अलर्ट',
  complianceAllCompliant: 'सगळ्या मशीन अनुपालनांत ✅',
  complianceColMachine: 'मशीन',
  complianceColOwner: 'मालक',
  complianceColInsurance: 'विमा',
  complianceColRcBook: 'RC बुक',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'सुरवात तारीख',
  complianceEndDate: 'समाप्ती तारीख',
  complianceExtractBtn: 'तारखा स्वयं भरण्याक तर कागद अपलोड करात',
  complianceExtractSuccess: 'तारखा काडल्यो — जतन करच्या आदी तपासात',
  complianceExtractError: 'तारखा काडूंक शकले ना — कृपया स्वहस्ते भरात',
  complianceExtracting: 'कागद वाचत आसा...',
  serviceHistory: 'सेवा इतिहास',
  serviceLastService: 'शेवटची सेवा',
  serviceNoRecords: 'अजून सेवा नोंदी नात',
  serviceNextDue: 'फुडलो सेवा देय',
  serviceNextHmr: 'फुडल्या सेवेत',
  serviceAddLog: 'सेवा लॉग जोडात',
  serviceDate: 'सेवा तारीख',
  serviceType: 'सेवा प्रकार',
  serviceHmr: 'सेवा HMR',
  serviceNextDate: 'फुडली सेवा तारीख',
  serviceWorkDone: 'केले काम',
  serviceNotes: 'नोंद',
  serviceTypeRoutine: 'नियमित',
  serviceTypeMajor: 'मुखेल',
  serviceTypeBreakdown: 'बिगाड',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'हेर',
  serviceOverdue: 'मुदत सोंपली',
  serviceDueSoon: 'लवकर देय',
  fleetAnalytics: 'फ्लीट विश्लेषण',
  analyticsRevenue: 'एकूण महसूल',
  analyticsBookings: 'एकूण बुकिंग',
  analyticsHours: 'एकूण वेळ',
  analyticsActiveMachines: 'सक्रिय मशीन',
  analyticsMonthlyTrend: 'मासिक महसूल ट्रेंड',
  analyticsMachineTable: 'मशीननुसार महसूल',
  analyticsNoData: 'ह्या काळात पूर्ण झालेल्या बुकिंग नाहीत',
  analyticsLastBooking: 'शेवटची बुकिंग',
  analytics3Months: '3 महिने',
  analytics6Months: '6 महिने',
  analytics12Months: '12 महिने',
  adminAnalytics: 'विश्लेषण',
  adminFleetTitle: 'फ्लीट विश्लेषण',
  adminFleetPlatformRevenue: 'प्लॅटफॉर्म महसूल',
  adminFleetActiveOwners: 'सक्रिय मालक',
  adminFleetOwnerCol: 'मालक',
  adminFleetMonthlyTrend: 'मासिक महसूल ट्रेंड',
  adminFleetMachineTable: 'मशीननुसार महसूल',
  adminFleetNoData: 'ह्या काळात पूर्ण झालेल्या बुकिंग नाहीत',
  adminFinancialIntelligence: 'मशीन आर्थिक माहिती',
  adminTotalInvested: 'एकूण गुंतवणूक',
  adminTotalEarned: 'एकूण कमाई',
  adminAvgRecovery: 'सरासरी वसुली',
  adminBreakEvenRate: 'ब्रेक-ईवन दर',
  adminProfitMargin: 'नफा मार्जिन',
  adminNoFinancialData: 'अद्याप आर्थिक डेटा असलेली मशीन नाही',
  adminMachineDetail: 'मशीन तपशील',
  adminCallOwner: 'मालकाला कॉल करा',
  adminWhatsappOwner: 'WhatsApp मालक',
  adminMarketRates: 'मार्केट रेट सबमिशन',
  adminMarketRateDelete: 'काढ',
  adminMarketRateDeleteConfirm: 'हो मार्केट रेट सबमिशन काढायचे?',
  adminMarketRateDeleted: 'मार्केट रेट काढले',
  adminMarketRateNoData: 'अद्याप मार्केट रेट सबमिशन ना',
  marketRateApprove: 'मान्य करात',
  marketRateReject: 'नाकारात',
  marketRateApproved: 'मान्य',
  marketRateRejected: 'नाकारले',
  marketRatePending: 'प्रलंबित',
  marketRateReviewed: 'मार्केट रेटची समीक्षा जाली',
  marketRatePendingReview: 'तुमचो दर सादर जाला आनी अॅडमिन समीक्षे खातीर प्रलंबित आसा.',
  marketRateEditApprove: 'संपादित करात आनी मान्य करात',
  marketRateEditMin: 'सुधारित किमान दर (₹/तास)',
  marketRateEditMax: 'सुधारित कमाल दर (₹/तास)',
  adminPayrollOverview: 'पगार विहंगावलोकन',
  adminPayrollTotalOperators: 'एकूण ऑपरेटर',
  adminPayrollTotalGross: 'एकूण देय रक्कम',
  adminPayrollTotalNet: 'एकूण निव्वळ देय',
  adminPayrollNoData: 'ह्या म्हयन्याक पगार डेटा ना',
  subTabSchedule: 'वेळापत्रक',
  subTabHistory: 'इतिहास',
  subTabAnalytics: 'विश्लेषण',
  clientAnalyticsTitle: 'बुकिंग विश्लेषण',
  clientAnalyticsSpend: 'एकूण खर्च',
  clientAnalyticsHours: 'एकूण तास',
  clientAnalyticsBookings: 'पूर्ण बुकिंग',
  clientAnalyticsMachines: 'वापरलेल्या मशीन',
  clientAnalyticsAvgSpend: 'प्रति बुकिंग सरासरी',
  clientAnalyticsMonthlyTrend: 'मासिक खर्च ट्रेंड',
  clientAnalyticsTopMachines: 'शीर्ष मशीन',
  clientAnalyticsNoData: 'ह्या काळात पूर्ण झालेल्या बुकिंग नाहीत',
  operatorAnalyticsTitle: 'काम विश्लेषण',
  operatorAnalyticsPresentDays: 'उपस्थित दिवस',
  operatorAnalyticsHalfDays: 'अर्ध दिवस',
  operatorAnalyticsHmr: 'एकूण HMR',
  operatorAnalyticsJobs: 'पूर्ण केलेली काम',
  operatorAnalyticsIssues: 'नोंदवलेले समस्या',
  operatorAnalyticsAvgHmr: 'सरासरी HMR/दिवस',
  operatorAnalyticsMonthlyTrend: 'मासिक काम ट्रेंड',
  operatorAnalyticsIssueBreakdown: 'प्रकारानुसार समस्या',
  operatorAnalyticsRecentJobs: 'अलीकडील काम',
  operatorAnalyticsNoData: 'ह्या काळात काम रेकॉर्ड नाहीत',
  adminServiceAlertsTitle: 'सेवा अलर्ट',
  adminServiceAllOk: 'सगळ्या मशीनांचे सेवा रेकॉर्ड अप-टू-डेट आसात ✅',
  adminServiceNoRecord: 'रेकॉर्ड ना',
  adminServiceColLastService: 'शेवटची सेवा',
  adminServiceColNextDue: 'फुडले Due',
  adminServiceColServiceStatus: 'सेवा स्थिती',
  adminMachinesColMinHrs: 'किमान वर',
  adminMachinesColRateDay: 'दर/दीस',
  adminClientName: 'ग्राहकाचें नांव',
  adminOwnerName: 'मालकाचें नांव',
  adminPayoutWallet: 'पेआउट वॉलेट',
  adminFooterMachines: 'मशीन',
  adminFooterClients: 'ग्राहक',
  adminFooterOwners: 'मालक',
  auditSeverityCritical: 'गंभीर',
  auditSeverityHigh: 'उच्च',
  auditSeverityMedium: 'मध्यम',
  auditSeverityNormal: 'सामान्य',
  auditCopyEvent: 'इवेंट कॉपी करात',
  auditViewDetails: 'तपशील पळयात',
  auditHideDetails: 'तपशील लिपयात',
  auditCopyJson: 'JSON कॉपी करात',
  auditNoLogs: 'ऑडिट लॉग ना',
  auditIntroBanner: 'लॉगिन, प्रशासक कृती आनी सुरक्षा घटना. फिल्टर लोड केल्ले निकालाचेर लागू जातात; जुन्या ओळी खातीर आनीक लोड करात.',
  auditLoaded: 'लोड केल्ले',
  auditMoreAvailable: 'आनीक उपलब्ध',
  auditEndOfList: 'यादी समाप्त',
  auditFilterActive: 'फिल्टर सक्रिय',
  auditFiltersActive: 'फिल्टर सक्रिय',
  auditSeverityBreakdown: 'गंभीरता विभाजन (सद्याची यादी)',
  auditPressSlash: 'कृती फिल्टराचेर फोकस करूंक / दाबात',
  auditFilters: 'फिल्टर',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'सगळ्यो भूमिका',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'मेटाडेटा JSON सोदात',
  auditFilterFromPlaceholder: 'सुरवात तारीख आनी वेळ',
  auditFilterToPlaceholder: 'सोंपणी तारीख आनी वेळ',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'वेळ क्षेत्र:',
  auditTimezoneSuffix: '(स्थानिक)',
  auditHideCsvOptions: 'CSV स्तंभ पर्याय लिपोवचे',
  auditShowCsvOptions: 'CSV स्तंभ पर्याय दाखोवचे',
  auditCsvColCreatedAt: 'निर्माण वेळ',
  auditCsvColAction: 'कृती',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'मेटाडेटा',
  auditFooterLoaded: 'लोड केल्ले',
  auditFooterLogs: 'ऑडिट लॉग',
  auditFooterMoreAvailable: '(आनीक उपलब्ध)',
  auditFooterAllLoaded: '(सगळे लोड केल्ले)',
  auditActor: 'एक्टर',
  auditEntity: 'घटक',
  auditEventLog: 'इवेंट लॉग',
  notificationCenter: 'अधिसूचना',
  notifChannelAll: 'सगळे',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ईमेल',
  notifChannelPush: 'पुश',
  notifChannelSms: 'SMS',
  notifStatusSent: 'धाडलें',
  notifStatusFailed: 'अपयशी',
  notifStatusPending: 'प्रलंबित',
  notifEmpty: 'अजून अधिसूचना नात',
  notifLoadMore: 'आनीक लोड करात',
  adminNotifLog: 'अधिसूचना लॉग',
  adminNotifColUser: 'वापरपी',
  adminNotifColRole: 'भूमिका',
  adminNotifNoData: 'अजून अधिसूचना लॉग नात',
  etaOwnerApproval: 'Malakachim manzurichea vatt polleita',
  etaWorkInProgress: 'Andajit poorn zatolem',
  etaPaymentDeadline: 'Payment confirm korpaichi xevti',
  etaWorkCompleted: 'Kam poorn zalem',
  etaDisputeReview: 'DE team vivadacho review korta',
  etaMinutesRemaining: '{n} minute urle',
  etaHoursRemaining: '{n} vor urle',
  txRecharge: 'वॉलेट रिचार्ज',
  txBookingAdvance: 'बुकिंग आगाऊ',
  txBookingPayment: 'बुकिंग पेमेंट',
  txSettlement: 'सेटलमेंट',
  txRefund: 'रिफंड',
  txPenalty: 'दंड',
  txCommission: 'कमिशन',
  tacTitle: "अटी आणि शर्ती",
  tacPrivacy: "गोपनीयता धोरण",
  tacRefund: "परतावा धोरण",
  tacCancellation: "रद्दीकरण धोरण",
  tacServiceDelivery: "सेवा वितरण धोरण",
  tacIntro: "बुकिंगपूर्वी आमची धोरणे पहा",
  tacBannerTitle: "अटी अपडेट उपलब्ध",
  tacBannerOpen: "अटी उघडा",
  tacBannerAgree: "मी वाचले आहे आणि सहमत आहे",
  tacBannerLater: "नंतर",
  clientPoliciesTitle: "ग्राहक धोरणे",
  machineGroupAvailable: "उपलब्ध",
  machineGroupBusy: "व्यस्त",
  dewateringReferral: "डीवॉटरिंग (पंप) सेवा हवी आहे? MachineOS लवकरच पंप कंत्राटदार सेवा जोडेल. रेफरलसाठी सपोर्टशी संपर्क साधा.",
  noActiveWork: "या महिन्यात सक्रिय काम नाही",
  accountTab: "खातें",
  recentActivity: "हालींचें काम",
  goodMorning: "सुप्रभात",
  goodAfternoon: "शुभ दुपार",
  goodEvening: "शुभ सांज",
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
};
